export default "__VITE_PUBLIC_ASSET__62bd9493__"